import {useSuggestiveSellingContext} from '../context/suggestive-selling-context';

export function useSuggestiveSelling() {
    return useSuggestiveSellingContext();
}
